<template>
  <div style="max-width: 900px">
    <div class="row ">
<!--      <a class="btn btn-primary mybutton ml-auto" href="#" @click="queryItem(false)">查詢</a>-->
<!--      <a class="btn btn-primary mybutton" href="javascript:location.reload()" >清除搜尋</a>-->
      <a class="btn btn-info mybutton " href="#" @click="addItem">新增</a>
      <a class="btn btn-danger mybutton" href="#" @click="deleteItem">刪除</a>
    </div>

    <MyGridEasyTable ref="grid" :datas.sync="gridDefine.datas" :columns="gridDefine.columns" :config="gridDefine.config"></MyGridEasyTable>
  </div>
</template>

<script>
import {
  QueryType_CheckIn_Index_Test,
} from "../js/checkInDeclare";
import MyGridEasyTable from "@/views/taylorAdmin/component/MyGridEasyTable";
import apiAdmin from "@/views/taylorAdmin/js/apiAdmin";
import util from "@/util/util";
/**

 **/
let editRouter="CheckInAdminCrudEdit";

export default {
  components: {MyGridEasyTable},
  //name: "Index",
  // props: [""],
  data: function () {
    return {
      QueryType_CheckIn_Index_Test:QueryType_CheckIn_Index_Test,
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      gridDefine:{
        config:{
          showColumnSeq:true,
          showColumnCheckBox:true,
          showColumnRadio:false,
        },
        columns:[
          { field: "f", key: "fzz", title: "功能", align: "center" ,width:100, renderBodyCell:  this.renderFunctionButton},
          { field: "name", key: "a", title: "Name", align: "center" ,sortBy:""},
          { field: "date", key: "b", title: "Date", align: "left",sortBy:"" },
          { field: "hobby", key: "c", title: "Hobby", align: "right" ,sortBy:"" },
          { field: "address", key: "d", title: "Address" ,sortBy:"" },
        ],
        // datas:[
        //   {
        //     SystemId: "John",
        //     name: "John",
        //     date: "1900-05-20",
        //     hobby: "coding and coding repeat",
        //     address: "No.1 Century Avenue, Shanghai",
        //   },
        //   {
        //     SystemId: "Dickerson",
        //     name: "Dickerson",
        //     date: "1910-06-20",
        //     hobby: "coding and coding repeat",
        //     address: "No.1 Century Avenue, Beijing",
        //   },
        //   {
        //     SystemId: "Larsen",
        //     name: "Larsen",
        //     date: "2000-07-20",
        //     hobby: "coding and coding repeat",
        //     address: "No.1 Century Avenue, Chongqing",
        //   },
        //   {
        //     SystemId: "Geneva",
        //     name: "Geneva",
        //     date: "2010-08-20",
        //     hobby: "coding and coding repeat",
        //     address: "No.1 Century Avenue, Xiamen",
        //   },
        //   {
        //     SystemId: "Jami",
        //     name: "Jami",
        //     date: "2020-09-20",
        //     hobby: "coding and coding repeat",
        //     address: "No.1 Century Avenue, Shenzhen",
        //   },
        // ],
      },
    };
  },
  methods: {
    async loadData() {
      let data=await apiAdmin.getContentList(this.QueryType_CheckIn_Index_Test);
      this.gridDefine.datas=apiAdmin.initReturnArray(data.data.data);
      // this.$refs.grid.refreshTableData(this.gridDefine.datas);
      this.$refs.grid.datas=this.gridDefine.datas;
      this.$refs.grid.resetTableData();
    },
    renderFunctionButton({ row, column, rowIndex },h) {  // eslint-disable-line
      return (
          <a role="button" class="btn btn-primary" on-click={() => this.editItem(row, column, rowIndex)}>編輯</a>

      );
    },
    addItem(){
      this.$router.push({ name: editRouter, query: { type: this.QueryType_CheckIn_Index_Test,SystemId:"" } })
    },
    editItem (row, column, rowIndex) {// eslint-disable-line
      this.$router.push({ name: editRouter, query: { type: this.QueryType_CheckIn_Index_Test,SystemId:row.SystemId } });
    },
    deleteItem(){
      let ids=this.$refs.grid.getSelectedRowKeys();

      if (ids.length>0){
        if (confirm('確定刪除?')){
          apiAdmin.api_deleteContentBySystemIds(ids).then(()=>{
            this.loadData();
          });
        }
      }else{
        util.ShowMessage('請先選擇欲刪除的資料');
      }
    },
  },
  mounted() {
    this.loadData()
  },
}
</script>

<style scoped>

</style>
